import { useEffect, useRef } from 'react';
import { useFilteringMaybe } from './Filtering';
import { usePaginationMaybe } from './Pagination';

export const useResetPageIndexOnFilterChange = (): void => {
  const filtering = useFilteringMaybe();
  const pagination = usePaginationMaybe();

  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render to avoid resetting the page index immediately.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    pagination?.setPageIndex(0);
  }, [
    filtering?.searchTerm,
    filtering?.forcedAt,
    JSON.stringify(filtering?.filters),
  ]);
};
